let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iLfzI")).then(() => parcelRequire('hwjHU'));